import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useCustomerDeliveredPrices(productNumber: string) {
  const { productService } = useService();

  const { data, isLoading, isFetching } = useQuery([QUERY_KEYS.customerPrices, productNumber], () =>
    productService.getCustomerDeliveredPrices(productNumber)
  );
  return { customerPrices: data, isLoading, isFetching } as const;
}
